import deepEqual from "fast-deep-equal/react";
import React from "react";

// pass old data when new data with a different identity but a deep equal value is passed
function useDistinctShape<T>(data: T) {
  const previousDataRef = React.useRef(data);
  const firstSimilarShapeDataRef = React.useRef(data);
  // if previous and current data are of different shape, reset firstSimilarShapeDataRef.current
  if (!deepEqual(previousDataRef.current, data))
    // compare current data with previous, to avoid repeating deep comparison with firstSimilarShapeDataRef.current (that might be costly each time, not only on transitions)
    firstSimilarShapeDataRef.current = data;
  previousDataRef.current = data;

  return firstSimilarShapeDataRef.current;
}

export default useDistinctShape;
